import { render, staticRenderFns } from "./TopMetrics.vue?vue&type=template&id=142a9b0b"
import script from "./TopMetrics.vue?vue&type=script&lang=js"
export * from "./TopMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports